import { render, staticRenderFns } from "./SourceItem.vue?vue&type=template&id=82ba4616&scoped=true&"
import script from "./SourceItem.vue?vue&type=script&lang=ts&"
export * from "./SourceItem.vue?vue&type=script&lang=ts&"
import style0 from "./SourceItem.vue?vue&type=style&index=0&id=82ba4616&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82ba4616",
  null
  
)

export default component.exports